<template>
  <div class="message" :class="{ mine: message.user.id === user.id }">
    <template v-if="message.type === 'system'">
      <div class="system-message" :id="`messages-${message.id}`">
        <div class="system-header">
          <span class="system-icon">📢</span>
          <span class="system-title">
            {{ message.title || "System Announcement" }}
          </span>
        </div>

        <div class="system-content" v-html="decodeMessage(message.message)" />

        <span class="time">{{ timeString }}</span>
      </div>
    </template>
    <template v-else>
      <div class="avatar">
        <img
          v-if="isPrevMessageUserSame"
          :src="message.user.avatar"
          alt="avatar"
        />
      </div>

      <div :id="`messages-${message.id}`" class="message-body">
        <p
          v-if="isLastMessageFromSameUser && user.id !== message.user.id"
          class="sender"
        >
          {{ message.user.name }}
        </p>

        <div class="message-content">
          <p
            v-html="decodeMessage(message.message)"
            :class="{
              'message-own': user.id === message.user.id,
            }"
            class="message-over"
          />
        </div>
        <span class="time">{{ timeString }}</span>
      </div>
    </template>
  </div>
</template>

<script lang="ts">
import { defineComponent, PropType } from "vue"
import { MessageType, UserType } from "../types"

export default defineComponent({
  name: "MessagesComponent",
  props: {
    message: {
      type: Object as PropType<MessageType>,
      required: true,
    },
    user: {
      type: Object as PropType<UserType>,
      required: true,
    },
    isPrevMessageUserSame: {
      type: Boolean,
      required: true,
    },
    isLastMessageFromSameUser: {
      type: Boolean,
      required: true,
    },
  },
  computed: {
    timeString() {
      const date = new Date(Number(this.message.created_at))

      const hours = date.getHours().toString().padStart(2, "0")
      const minutes = date.getMinutes().toString().padStart(2, "0")

      return `${hours}:${minutes}`
    },
  },
  methods: {
    decodeMessage(message: string): string {
      if (!message) return ""

      const temp = document.createElement("div")
      temp.innerHTML = message
      const messageContent = temp.textContent || temp.innerText || ""

      const escaped = messageContent
        .replace(/&/g, "&amp;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;")

      const mentions = escaped.replace(
        /@(\w+)/g,
        `<span class="mention-item">@$1</span>`
      )

      const withLineBreaks = mentions.replace(/\n/g, "<br>")

      return withLineBreaks
    },
  },
})
</script>

<style lang="scss" scoped>
@import "../index.scss";
</style>
